import React, { useState, useEffect } from 'react';
import { fetchCompanies } from '../../../controller/companyController'; // Importar la función de la API
import CompanyModel from '../../../models/company'; // Importar el modelo de la empresa
import { Container, Table, Button } from 'react-bootstrap'; // Importar componentes de Bootstrap
import { PencilSquare } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

function CompanyView() {
  const [companies, setCompanies] = useState([]); // Estado para almacenar las empresas
  const [loading, setLoading] = useState(true); // Estado para saber si estamos cargando
  const navigate = useNavigate(); // Hook para la navegación


  // Llamar a la API para obtener las empresas cuando el componente se monte
  useEffect(() => {
    const getCompanies = async () => {
      try {
        const data = await fetchCompanies();
        // Convertir cada empresa a una instancia del modelo Company
        const companiesData = data.map((companyData) => new CompanyModel(companyData));
        setCompanies(companiesData); // Actualizar el estado con las empresas
      } catch (error) {
        console.error('Error al obtener las empresas:', error);
      } finally {
        setLoading(false); // Finalizamos la carga
      }
    };
    
    getCompanies(); // Llamamos la función para obtener las empresas
  }, []); // El arreglo vacío asegura que se ejecute solo una vez al montar el componente

  // Si estamos cargando, mostrar un mensaje de carga
  if (loading) {
    return <h1>Cargando empresas...</h1>;
  }

    // Manejar la navegación al formulario de edición
  const handleEdit = (company) => {
    navigate(`/company/editCompany`, { state: { company } });
  };

  // Mostrar la lista de empresas
 return (
  <Container className="mt-4">
  <h1 className="mb-4">Empresas</h1>
  <Table striped bordered hover>
    <thead>
      <tr>
        <th>Nombre</th>
        <th>Ubicacion</th>
        <th>Telefono</th>
        <th>Acciones</th>
      </tr>
    </thead>
    <tbody>
      {companies.map((company) => (
        <tr key={company.id}>
          <td>{company.name}</td>
          <td>{company.address || 'No disponible'}</td>
        <td>{company.phone_number}</td>
          <td>
          <Button variant="light" size="sm" onClick={() => handleEdit(company)}>
                  <PencilSquare color="blue" />
            </Button>
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
</Container>
);
}

export default CompanyView;
